import React from "react"
import {EvaluationFlags, EntityEvaluation} from "../EvaluationFlags/EvaluationFlags"
import {Officer} from "../../resources/application"
import {BeneficialOwnerResource} from "../../resources/beneficialOwner"
import {BusinessProductApplication} from "../../resources/productApplication"

interface EvaluationFlagsBusinessProductApplicationProps {
	application: BusinessProductApplication
	officer?: Officer
	beneficialOwners?: BeneficialOwnerResource[]
}

export default function EvaluationFlagsBusinessProductApplication({
	application,
	officer,
	beneficialOwners,
}: EvaluationFlagsBusinessProductApplicationProps) {
	return (
		<div className="card">
			<div className="card-header">
				<p className="card-header-title">Evaluation Flags</p>
			</div>
			<div className="card-content grid-card-content">
				<EvaluationFlags title="Business" flags={application.attributes.evaluationFlags} />
				{officer && (
					<EntityEvaluation title="Officer" flags={officer.evaluationFlags} idTheftScore={officer.idTheftScore} />
				)}
				{beneficialOwners?.map((bo) => (
					<EntityEvaluation
						key={bo.attributes.fullName.first + bo.attributes.fullName.last}
						title={`Beneficial Owner - ${bo.attributes.fullName.first} ${bo.attributes.fullName.last}`}
						flags={bo.attributes.evaluationFlags}
						idTheftScore={bo.attributes.idTheftScore}
					/>
				))}
			</div>
		</div>
	)
}
